/**
 * Genera un slug a partir de un string, similar a Django's slugify
 * @param {string} text - El texto a convertir en slug
 * @returns {string} - El slug generado
 */
export const generateSlug = (text) => {
  if (!text) return '';
  
  return text
    .toLowerCase()
    .trim()
    // Reemplazar espacios y caracteres especiales con guiones
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    // Remover guiones al inicio y final
    .replace(/^-+|-+$/g, '');
};

/**
 * Genera la URL completa de un bote
 * @param {Object} boat - Objeto del bote con id y name
 * @returns {string} - URL completa del bote
 */
export const generateBoatUrl = (boat) => {
  if (!boat || !boat.id || !boat.name) return '';
  
  const slug = generateSlug(boat.name);
  return `/boats/${boat.id}/${encodeURIComponent(slug)}`;
}; 